/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import CreateSkillBasedQueueBreadcrumbs from 'domain/gpo/skillBasedQueue/createupdate/Create/Breadcrumbs';
import { useSkillBasedQueueId, useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';
import useSkillBasedQueueService from 'domain/gpo/skillBasedQueue/shared/skillBasedQueueService';
import SkillBasedQueueForm from 'domain/gpo/skillBasedQueue/createupdate/SkillBasedQueueForm';

const CreateSkillBasedQueue = () => {
  const { create, getValidationSchema, getById } = useSkillBasedQueueService();
  const { getListUrl } = useSkillBasedQueueUrl();
  const id = useSkillBasedQueueId();
  let getDataFunc;

  if (id) {
    getDataFunc = () => getById(id);
  }

  return (
    <CreateForm
      getDataFunc={getDataFunc}
      submitFormFunc={create}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Skill Based Queue has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Skill Based Queue" breadcrumbs={<CreateSkillBasedQueueBreadcrumbs />}>
        <SkillBasedQueueForm isCreateForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateSkillBasedQueue;
